/**
 * Etichette e colori della riconciliazione, condivisi dalle due pagine.
 *
 * In un modulo senza componenti per una ragione pratica oltre che di ordine:
 * un file che esporta insieme componenti e costanti rompe il fast refresh, e
 * la stessa separazione esiste gia' in `reports/report-format.ts`.
 */

/**
 * Il colore dello stato di una proposta. Condiviso per la stessa ragione del
 * disegno: lo stesso esito non deve cambiare colore a seconda di dove lo si
 * guarda.
 */
export const STATUS_TONE: Record<string, 'positive' | 'negative' | 'neutral' | 'accent'> = {
  executed: 'positive',
  approved: 'accent',
  rejected: 'negative',
  deferred: 'neutral',
  proposed: 'neutral',
  dry_run: 'neutral',
};
